import { useEffect, useState, useRef } from 'react';

export function useScrollObserver(elementClass: string) {
    const observer = useRef<IntersectionObserver | null>(null);
    const [activeId, setActiveId] = useState('');

    useEffect(() => {
        const handleObsever: IntersectionObserverCallback = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setActiveId(entry.target.id);
                }
            });
        };

        observer.current = new IntersectionObserver(handleObsever, {
            rootMargin: '0px 0% -80% 0px', //"-20% 0% -35% 0px"
        });

        const elements = document.querySelectorAll(elementClass);

        if (observer.current) {
            elements.forEach((elem) => observer.current?.observe(elem));
        }
        return () => observer.current?.disconnect();
    }, [elementClass]);

    return { activeId };
}
